import React from "react";
import Select from "react-select/creatable";
import Modal from "../../Shared/PopupModal/PopupModal";
import UpgradeModal from "../../UpgradeModal/UpgradeModal";
import RequestApproval from "./Approval/RequestApproval";
import PendingApproval from "./Approval/PendingApproval";
import Auctions from "../Auctions/Auctions";
import { DownloadReports } from "./DownloadReport/DeliveryReport";
import MyLsp from "./MyLsp";
import { isMobile, Activity, currentRequestTimeStamp, spotFilterOptions } from "../../../Constants";
import classes from "../TrucksAvailable.module.css";

const EnquiryToolbar = ({
  isdownload,
  interval_days,
  enquiryBucket,
  enquiryLevel,
  canAccessReports,
  auctionAllowed,
  isAuction,
  allowed_auction,
  requestapprovallist,
  company_name,
  isRestricted,
  showapprovingloader,
  isApprover,
  approver_list,

  autoPushIndent,
  setsend_data,
  enquiryTransition,
  setmastertransporterlist,
  planningbutton,
  history,
  apply_Filter,
  setFilters_applied,
  setselected_user,
  setselected_truck_type,
  setselected_origin_name,
  setselected_destination_name,
  setselected_placement_date,
  setselected_contract,
  setRequestapprovallist,
  setEnquiryBucket,
  TrackMixPanel,
  visible_enquiry,
  expiredEnquiries,
  cancelEnquiry,
  approveEnquiry,
  iscompanycheck,
  userview,
  setuserview,
  setEnquiryLevel,
  closeModal1,
  cancelApprovalPending,
  children,
  backbutton,
  discovernowbutton,
  setFilter,
  handleOutsideFilterChange,
  companySettingData
}) => {
  const bucketOptions = [
    { value: "all", label: "All Enquiry" },
    { value: "active", label: "Active Enquiry" },
    { value: "cancelled", label: "Cancelled Enquiry" },
    { value: "archived", label: "Archived Enquiry" },
    { value: "approved", label: "Approved Enquiry" },
    ...(companySettingData?.enquiry?.post_expiry_acceptance === true
      ? isApprover
        ? [{ value: "pending_approval", label: "Pending Approval" }]
        : [{ value: "pending_acceptance", label: "Pending Acceptance" }]
      : []),
  ];
  return (
    <div
      className="row"
      style={{
        margin: "0% 0% 0% 2%",
        justifyContent: "center",
        width: "100%",
        marginLeft: isMobile() ? 0 : undefined,
        marginRight: isMobile() ? 0 : undefined,
      }}
    >
      {isMobile() ? (
        <div
          className={classes["mobileScrollRow"]}
          style={{
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            padding: "8px 15px",
            margin: "0",
            minWidth: 0,
            maxWidth: "100%",
            alignItems: "center",
          }}
        >
          <button
            className="btn btn-sm btn-primary tr-button1"
            style={{
              margin: "0 0%",
              fontSize: "13px",
              height: "33px",
              padding: "0 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
            onClick={() => setFilter(true)}
            title="Filter"
          >
            <i className="fa fa-filter" />
          </button>

          {!backbutton && !discovernowbutton && !planningbutton && (
            <>
              <div style={{ margin: "0 5% 0 0%", flexShrink: 0 }}>
                {isdownload && (
                  <Modal
                    buttonLabel={<>Download Report</>}
                    buttonClass="btn btn-sm btn-primary tr-button1"
                    content={
                      <DownloadReports
                        days={interval_days}
                        bucket={enquiryBucket}
                        level={enquiryLevel}
                        screen={"spot"}
                      />
                    }
                    title={<b>Report Generator</b>}
                    id="closebutton"
                    size={"lg"}
                    screenName="LoRRI Spot"
                    moduleName="My Enquiries"
                    activityName={`Download Report`}
                    backdrop={false}
                    style={{
                      fontSize: "13px",
                      margin: "2% -5%",
                      cursor: canAccessReports ? "pointer" : "not-allowed",
                      opacity: canAccessReports ? 1 : 0.6,
                    }}
                    disabled={canAccessReports ? false : true}
                  />
                )}
              </div>

              <div style={{ margin: "0 5% 0 0%", flexShrink: 0 }}>
                {auctionAllowed === "yes" &&
                  isAuction &&
                  allowed_auction > 0 ? (
                  <Modal
                    buttonLabel={`Create Auctions`}
                    buttonClass="btn btn-sm btn-primary"
                    content={
                      <Auctions
                        auctionlist={requestapprovallist}
                        company_name={company_name}
                      />
                    }
                    title={`Create Auctions`}
                    id="closebutton"
                    screenName="LoRRI Spot"
                    moduleName="My Enquiries"
                    activityName={`Request Approval Button Clicked`}
                    dialogClassName={classes.pendingmodal}
                    backdrop={false}
                    onClose={closeModal1}
                    style={{
                      fontSize: "13px",
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                  />
                ) : (
                  <UpgradeModal
                    screenName="LoRRI Spot"
                    moduleName="Upgrade Popup"
                    activityName="Create auction button clicked"
                    buttonClass="btn btn-sm btn-primary"
                    buttonLabel="Create Auctions"
                    feature="Create Auctions"
                    style={{
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                  />
                )}
              </div>

              {!showapprovingloader &&
                (!isApprover ? (
                  <div style={{ margin: "0 1%", flexShrink: 0 }}>
                    <Modal
                      buttonLabel={`Request Approval`}
                      buttonClass="btn btn-sm btn-primary"
                      content={
                        <RequestApproval
                          requestapprovallist={requestapprovallist}
                          approverList={approver_list}

                        />
                      }
                      title={`Request Approval`}
                      subtitle="Note: Only enquiries which are Accepted and Not Approved can be sent for approval"
                      id="closebutton"
                      size={"lg"}
                      screenName="LoRRI Spot"
                      moduleName="My Enquiries"
                      activityName={`Request Approval Button Clicked`}
                      dialogClassName={classes.pendingmodal}
                      backdrop={false}
                      style={{
                        fontSize: "13px",
                        margin: "2% -5%",
                        cursor: isRestricted ? "not-allowed" : "pointer",
                        opacity: isRestricted ? 0.6 : 1,
                      }}
                      disabled={isRestricted}
                    />
                  </div>
                ) : (
                  <div style={{ margin: "0 1%", flexShrink: 0 }}>
                    <Modal
                      buttonLabel={
                        isMobile()
                          ? "Pending Approvals"
                          : "Click Here to check Pending Approvals"
                      }
                      buttonClass="btn btn-sm btn-primary"
                      content={
                        <PendingApproval
                          autoPushIndent={autoPushIndent}
                          setsend_data={setsend_data}
                          enquiryTransition={enquiryTransition}
                        />
                      }
                      title={`Enquiry Pending for Approval`}
                      id="pendingApprovalCloseButton"
                      size={"md"}
                      screenName="LoRRI Spot"
                      moduleName="My Enquiries"
                      activityName={`Request Approval Button Clicked`}
                      backdrop={false}
                      dialogClassName={classes.pendingmodal}
                      style={{
                        fontSize: "13px",
                        cursor: isRestricted ? "not-allowed" : "pointer",
                        opacity: isRestricted ? 0.6 : 1,
                      }}
                      onClose={cancelApprovalPending}
                      disabled={isRestricted}
                    />
                  </div>
                ))}
            </>
          )}

          <div style={{ flexShrink: 0, margin: "0 1%" }}>
            <Modal
              buttonLabel={`Add Recommended Transporters`}
              disabled={isRestricted}
              buttonClass={`btn btn-sm btn-primary  ${classes["shortlist-button"]} `}
              content={
                <MyLsp
                  setmastertransporterlist={setmastertransporterlist}
                  planningbutton={planningbutton}
                />
              }
              title={`Add Recommended Transporters`}
              id="closebutton"
              screenName="LoRRI Spot"
              moduleName="My Enquiries"
              activityName={`Add Transporter Button clicked`}
              backdrop={false}
              size={isMobile() ? "sm" : "md"}
              style={{
                fontSize: "13px",
                height: "33px",
                cursor: isRestricted ? "not-allowed" : "pointer",
                opacity: isRestricted ? 0.6 : 1,
              }}
            />
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "50%",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <button
            className="btn btn-sm btn-primary tr-button1"
            style={{
              margin: "0 1%",
              fontSize: "13px",
              height: "33px",
              padding: "0 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => setFilter(true)}
            title="Filter"
          >
            <i className="fa fa-filter" />
          </button>

          {!backbutton && !discovernowbutton && !planningbutton && (
            <>
              <div style={{ margin: "0 1%" }}>
                {isdownload && (
                  <Modal
                    buttonLabel={<>Download Report</>}
                    buttonClass="btn btn-sm btn-primary tr-button1"
                    content={
                      <DownloadReports
                        days={interval_days}
                        bucket={enquiryBucket}
                        level={enquiryLevel}
                        screen={"spot"}
                      />
                    }
                    title={<b>Report Generator</b>}
                    id="closebutton"
                    size={"lg"}
                    screenName="LoRRI Spot"
                    moduleName="My Enquiries"
                    activityName={`Download Report`}
                    backdrop={false}
                    style={{
                      fontSize: "13px",
                      margin: "",
                      cursor: canAccessReports ? "pointer" : "not-allowed",
                      opacity: canAccessReports ? 1 : 0.6,
                    }}
                    disabled={canAccessReports ? false : true}
                  />
                )}
              </div>

              <div style={{ margin: "0 1%" }}>
                {auctionAllowed === "yes" &&
                  isAuction &&
                  allowed_auction > 0 ? (
                  <Modal
                    buttonLabel={`Create Auctions`}
                    buttonClass="btn btn-sm btn-primary"
                    content={
                      <Auctions
                        auctionlist={requestapprovallist}
                        company_name={company_name}
                      />
                    }
                    title={`Create Auctions`}
                    id="closebutton"
                    screenName="LoRRI Spot"
                    moduleName="My Enquiries"
                    activityName={`Request Approval Button Clicked`}
                    dialogClassName={classes.pendingmodal}
                    backdrop={false}
                    onClose={closeModal1}
                    style={{
                      fontSize: "13px",
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                  />
                ) : (
                  <UpgradeModal
                    screenName="LoRRI Spot"
                    moduleName="Upgrade Popup"
                    activityName="Create auction button clicked"
                    buttonClass="btn btn-sm btn-primary"
                    buttonLabel="Create Auctions"
                    feature="Create Auctions"
                    style={{
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                  />
                )}
              </div>

              {!showapprovingloader &&
                (!isApprover ? (
                  <div style={{ margin: "0 1%" }}>
                    <Modal
                      buttonLabel={`Request Approval`}
                      buttonClass="btn btn-sm btn-primary"
                      content={
                        <RequestApproval
                          requestapprovallist={requestapprovallist}
                          approverList={approver_list}

                        />
                      }
                      title={`Request Approval`}
                      subtitle="Note: Only enquiries which are Accepted and Not Approved can be sent for approval"
                      id="closebutton"
                      size={"lg"}
                      screenName="LoRRI Spot"
                      moduleName="My Enquiries"
                      activityName={`Request Approval Button Clicked`}
                      dialogClassName={classes.pendingmodal}
                      backdrop={false}
                      style={{
                        fontSize: "13px",
                        margin: "",
                        cursor: isRestricted ? "not-allowed" : "pointer",
                        opacity: isRestricted ? 0.6 : 1,
                      }}
                      disabled={isRestricted}
                    />
                  </div>
                ) : (
                  <div style={{ margin: "0 1%" }}>
                    <Modal
                      buttonLabel={
                        isMobile()
                          ? "Pending Approvals"
                          : "Click Here to check Pending Approvals"
                      }
                      buttonClass="btn btn-sm btn-primary"
                      content={
                        <PendingApproval
                          autoPushIndent={autoPushIndent}
                          setsend_data={setsend_data}
                          enquiryTransition={enquiryTransition}
                        />
                      }
                      title={`Enquiry Pending for Approval`}
                      id="pendingApprovalCloseButton"
                      size={"md"}
                      screenName="LoRRI Spot"
                      moduleName="My Enquiries"
                      activityName={`Request Approval Button Clicked`}
                      backdrop={false}
                      dialogClassName={classes.pendingmodal}
                      style={{
                        fontSize: "13px",
                        cursor: isRestricted ? "not-allowed" : "pointer",
                        opacity: isRestricted ? 0.6 : 1,
                      }}
                      onClose={cancelApprovalPending}
                      disabled={isRestricted}
                    />
                  </div>
                ))}
            </>
          )}
        </div>
      )}
      <div style={{ width: isMobile() ? "" : "50%", minWidth: isMobile() ? 0 : undefined, maxWidth: isMobile() ? "100%" : undefined }}>
        {isMobile() ? (

          <div
            className={classes["mobileScrollRow"]}
            style={{
              display: "flex",
              flexWrap: "nowrap",
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              padding: "8px 15px",
              margin: "0",
              minWidth: 0,
              maxWidth: "100%",
              alignItems: "center",
            }}
          >

            <div style={{ width: "120px", marginRight: "1%", flexShrink: 0 }}>
              <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={spotFilterOptions[1]}
                name="days"
                options={spotFilterOptions}
                isValidNewOption={() => false}
                isSearchable={false}
                value={spotFilterOptions.find((obj) => obj.value === interval_days)}
                onChange={(e) => handleOutsideFilterChange("days", e.value)}
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: "13px",
                    minHeight: "38px",
                    height: "38px",
                    borderRadius: "4px",
                    borderColor: "#dee2e6",
                    boxShadow: "none",
                    textAlign: "center",
                    "&:hover": {
                      borderColor: "#ced4da",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    justifyContent: "center",
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: "#dee2e6",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "#333",
                    width: "100%",
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </div>

            <div style={{ width: "160px", marginRight: "1%", flexShrink: 0 }}>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isValidNewOption={() => false}
                isSearchable={false}
                name="bucket"
                options={bucketOptions}
                value={{
                  value: enquiryBucket,
                  label:
                    enquiryBucket === "active"
                      ? "Active Enquiry"
                      : enquiryBucket === "cancelled"
                        ? "Cancelled Enquiry"
                        : enquiryBucket === "expired" || enquiryBucket === "archived"
                          ? "Archived Enquiry"
                          : enquiryBucket === "approved"
                            ? "Approved Enquiry"
                            : enquiryBucket === "pending_approval"
                              ? "Pending Approval"
                              : enquiryBucket === "pending_acceptance"
                                ? "Pending Acceptance"
                                : "All Enquiry",
                }}
                onChange={(e) => handleOutsideFilterChange("bucket", e.value)}
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: "13px",
                    minHeight: "38px",
                    height: "38px",
                    borderRadius: "4px",
                    borderColor: "#dee2e6",
                    boxShadow: "none",
                    textAlign: "center",
                    "&:hover": {
                      borderColor: "#ced4da",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    justifyContent: "center",
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: "#dee2e6",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "#333",
                    width: "100%",
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </div>

            {iscompanycheck && (
              <div style={{ width: "160px", flexShrink: 0 }}>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  name="view"

                  options={[
                    { value: "user_view", label: "My Enquiries" },
                    { value: "company_view", label: "Company Enquiries" },
                  ]}
                  value={{
                    value: enquiryLevel,
                    label:
                      enquiryLevel === "user_view"
                        ? "My Enquiries"
                        : "Company Enquiries",
                  }}
                  onChange={(e) => {
                    handleOutsideFilterChange("view", e.value);
                    setuserview(e.value === "user_view");
                  }}
                  menuPortalTarget={document.body}
                  styles={{
                    control: (base) => ({
                      ...base,
                      fontSize: "13px",
                      minHeight: "38px",
                      height: "38px",
                      borderRadius: "4px",
                      borderColor: "#dee2e6",
                      boxShadow: "none",
                      textAlign: "center",
                      "&:hover": {
                        borderColor: "#ced4da",
                      },
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      justifyContent: "center",
                    }),
                    indicatorSeparator: (base) => ({
                      ...base,
                      backgroundColor: "#dee2e6",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "#333",
                      width: "100%",
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  isValidNewOption={() => false}
                  isSearchable={false}
                />
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Modal
              buttonLabel={`Add Recommended Transporters`}
              disabled={isRestricted}
              buttonClass={`btn btn-sm btn-primary ${classes["shortlist-button"]} `}
              content={
                <MyLsp
                  setmastertransporterlist={setmastertransporterlist}
                  planningbutton={planningbutton}
                />
              }
              title={`Add Recommended Transporters`}
              id="closebutton"
              screenName="LoRRI Spot"
              moduleName="My Enquiries"
              activityName={`Add Transporter Button clicked`}
              backdrop={false}
              size={isMobile() ? "sm" : "md"}
              style={{
                fontSize: "13px",
                height: "33px",
                marginRight: "2%",
                marginBottom: isMobile() ? "3%" : "",
                cursor: isRestricted ? "not-allowed" : "pointer",
                opacity: isRestricted ? 0.6 : 1,
              }}
            />

            <div style={{ width: "120px", marginRight: "1%" }}>
              <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={spotFilterOptions[1]}
                name="days"
                options={spotFilterOptions}
                isValidNewOption={() => false}
                isSearchable={false}
                value={spotFilterOptions.find((obj) => obj.value === interval_days)}
                onChange={(e) => handleOutsideFilterChange("days", e.value)}
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: "13px",
                    minHeight: "38px",
                    height: "38px",
                    borderRadius: "4px",
                    borderColor: "#dee2e6",
                    boxShadow: "none",
                    textAlign: "center",
                    "&:hover": {
                      borderColor: "#ced4da",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    justifyContent: "center",
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: "#dee2e6",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "#333",
                    width: "100%",
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </div>

            <div style={{ width: "160px", marginRight: "1%" }}>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isValidNewOption={() => false}
                isSearchable={false}
                name="bucket"
                options={bucketOptions}
                value={{
                  value: enquiryBucket,
                  label:
                    enquiryBucket === "active"
                      ? "Active Enquiry"
                      : enquiryBucket === "cancelled"
                        ? "Cancelled Enquiry"
                        : enquiryBucket === "expired" || enquiryBucket === "archived"
                          ? "Archived Enquiry"
                          : enquiryBucket === "approved"
                            ? "Approved Enquiry"
                            : enquiryBucket === "pending_approval"
                              ? "Pending Approval"
                              : enquiryBucket === "pending_acceptance"
                                ? "Pending Acceptance"
                                : "All Enquiry",
                }}
                onChange={(e) => handleOutsideFilterChange("bucket", e.value)}
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: "13px",
                    minHeight: "38px",
                    height: "38px",
                    borderRadius: "4px",
                    borderColor: "#dee2e6",
                    boxShadow: "none",
                    textAlign: "center",
                    "&:hover": {
                      borderColor: "#ced4da",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    justifyContent: "center",
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: "#dee2e6",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "#333",
                    width: "100%",
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </div>

            {iscompanycheck && (
              <div style={{ width: "160px" }}>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  name="view"

                  options={[
                    { value: "user_view", label: "My Enquiries" },
                    { value: "company_view", label: "Company Enquiries" },
                  ]}
                  value={{
                    value: enquiryLevel,
                    label:
                      enquiryLevel === "user_view"
                        ? "My Enquiries"
                        : "Company Enquiries",
                  }}
                  onChange={(e) => {
                    handleOutsideFilterChange("view", e.value);
                    setuserview(e.value === "user_view");
                  }}
                  menuPortalTarget={document.body}
                  styles={{
                    control: (base) => ({
                      ...base,
                      fontSize: "13px",
                      minHeight: "38px",
                      height: "38px",
                      borderRadius: "4px",
                      borderColor: "#dee2e6",
                      boxShadow: "none",
                      textAlign: "center",
                      "&:hover": {
                        borderColor: "#ced4da",
                      },
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      justifyContent: "center",
                    }),
                    indicatorSeparator: (base) => ({
                      ...base,
                      backgroundColor: "#dee2e6",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "#333",
                      width: "100%",
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  isValidNewOption={() => false}
                  isSearchable={false}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EnquiryToolbar;